import React, { useState } from "react";
import Textarea from "../../../../components/FormComponents/Textarea";
import Button from "../../../../components/FormComponents/Button";

const RDBMSUpload = ({ handleAddJsonConfig }) => {
  const [textareaValue, setTextareaValue] = useState("");

  return (
    <div className="builder_form">
      <Textarea value={textareaValue} onChange={(e) => setTextareaValue(e.target.value)} />
      <Button onClick={() => handleAddJsonConfig(textareaValue)}>Upload</Button>
    </div>
  );
};

export default RDBMSUpload;
